module.exports = __webpack_public_path__ + "img/trsd_nl_ico.b99c9937.png";